import L from 'leaflet'
import MapPopup from '@/utils/map/popup/MapPopup'
import menuGroups from '@/config/regions/parts/menuGroups'
import { map as mapEndpoints } from '@/api/api-endpoints'
import { getMSNIcon, getGarbageIcon, getTkoIcon } from '@/utils/map/icon'
import { COLORS } from '@/utils'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import url from '@/utils/url'

export default {
  data() {
    return {
      showSearch: false,
      suggestionMapSearch: {
        garbageSearch: '',
        tkoObjectSearch: '',
        msnSearch: '',
        atuSearch: '',
      },
      searchLayer: null,
      searchGarbageLayer: null,
      searchTkoObjectLayer: null,
      searchMsnLayer: null,
      atuLayer: L.layerGroup(),
    }
  },
  methods: {
    clearSearchResult() {
      if (this.searchLayer) {
        this.map.removeLayer(this.searchLayer)
      }
      this.searchLayer = L.layerGroup()
      this.map.addLayer(this.searchLayer)
      this.suggestionMapSearch = {
        garbageSearch: '',
        tkoObjectSearch: '',
        msnSearch: '',
        atuSearch: '',
      }
    },
    clearCurrentSearchResults(layer) {
      if (layer) {
        this.searchLayer.removeLayer(layer)
      }
    },
    async selectGarbageOnMapSearch($event) {
      if (this.searchGarbageLayer) {
        this.searchLayer.removeLayer(this.searchGarbageLayer)
      }
      this.suggestionMapSearch.garbageSearch = $event.name
      const iconType = getGarbageIcon($event.garbage_source_type_id)
      const subClassName =
        menuGroups[getGarbageIcon($event.garbage_source_type_id)].iconType
      const endpointForMarkers = mapEndpoints.sourceById($event.id)
      const latLng = L.latLng($event.lat, $event.lng)
      const id = $event.id
      this.searchGarbageLayer = L.layerGroup()

      this.showMarker({
        id,
        iconType,
        className: 'wasteCreators',
        subClassName,
        status: $event.status_code,
        latLng,
        endpointForMarkers,
        layer: this.searchGarbageLayer,
      })
    },
    async selectTkoObjectOnMapSearch($event) {
      if (this.searchTkoObjectLayer) {
        this.searchLayer.removeLayer(this.searchTkoObjectLayer)
      }
      this.suggestionMapSearch.tkoObjectSearch = $event.name
      const iconType = getTkoIcon($event.tko_action[0].id)
      const subClassName =
        menuGroups[getTkoIcon($event.tko_action[0].id)].iconType
      const endpointForMarkers = mapEndpoints.objectById($event.id)
      const latLng = L.latLng($event.latitude, $event.longitude)
      const id = $event.id
      this.searchTkoObjectLayer = L.layerGroup()

      this.showMarker({
        id,
        iconType,
        className: 'garbage',
        subClassName,
        status: $event.status.code,
        latLng,
        endpointForMarkers,
        layer: this.searchTkoObjectLayer,
      })
    },
    async selectMsnOnMapSearch($event) {
      if (this.searchMsnLayer) {
        this.searchLayer.removeLayer(this.searchMsnLayer)
      }
      this.suggestionMapSearch.msnSearch = $event.name
      const iconType = getMSNIcon($event.type)
      const subClassName = menuGroups[getMSNIcon($event.type)].iconType
      const endpointForMarkers = mapEndpoints.msnById($event.id)
      const latLng = L.latLng($event.lat, $event.lng)
      const id = $event.id
      this.searchMsnLayer = L.layerGroup()

      this.showMarker({
        id,
        iconType,
        className: 'places',
        subClassName,
        status: $event.status_code,
        latLng,
        endpointForMarkers,
        layer: this.searchMsnLayer,
      })
    },
    async selectAtuOnMapSearch($event) {
      this.suggestionMapSearch.atuSearch = $event.name
      if (this.atuLayer) {
        this.atuLayer.clearLayers()
        this.map.removeLayer(this.atuLayer)
      }
      if ($event.polygon) {
        let polygon = JSON.parse(JSON.parse($event.polygon))
        polygon = polygon.flat()
        const polygonReversed = polygon.map((item) => {
          return [item[1], item[0]]
        })
        const poly = L.polygon(polygonReversed, {
          color: COLORS.red,
          fillColor: COLORS.red,
          fillOpacity: 0,
          weight: 1,
        })
        this.atuLayer.addLayer(poly)
      }
      const marker = this.createIcon({
        id: $event.id,
        name: $event.name,
        latitude: $event.lat,
        longitude: $event.lon,
      })
      marker.addTo(this.atuLayer)
      this.atuLayer.addTo(this.map)
    },
    addActionsToAtuPopup() {
      document.addEventListener('click', async (e) => {
        if (e.target.classList.contains('js-view-atu')) {
          const id = e.target.dataset.id
          this.$router.push({
            name: 'atu.objects.update',
            params: { id },
            query: {
              prevRoute: url.getRoute(this.$route, true),
            },
          })
        }
      })
    },
    addContentToAtuPopup({ id, name }) {
      return `<div class='map-popup'>
                <div class="map-popup__body">
                     <div class='map-popup__title'>${name}</div>
                    <hr>
                     <button class="js-view-atu reset-btn button" data-id="${id}">Подробнее</button>
                </div>
            </div>
        `
    },
    createIcon({ id, name, latitude, longitude }) {
      const icon = L.icon({
        iconUrl: markerIcon,
        shadowUrl: iconShadow,
        iconSize: [25, 41],
        iconAnchor: [13, 20],
      })
      const iconLayer = L.marker([latitude, longitude], {
        icon: icon,
      })
      const popup = L.popup()
      popup.setContent(this.addContentToAtuPopup({ id, name }))
      iconLayer.bindPopup(popup)
      return iconLayer
    },
    showMarker({
      id,
      iconType,
      className,
      subClassName,
      status,
      latLng,
      endpointForMarkers,
      layer,
    }) {
      const iconClassName = `map-icon map-icon_${className} map-icon_${subClassName} ${status}`

      const myIcon = L.divIcon({
        className: 'my-div-icon',
        html: `<div class="${iconClassName}"><div class="map-icon__point"></div></div>`,
      })
      const marker = L.marker(latLng, {
        icon: myIcon,
      })
      const popup = new MapPopup({
        id: id,
        layerConfig: { endpoint: endpointForMarkers },
        subLayerConfig: {
          iconType,
        },
      })
      marker.bindPopup(popup)
      layer.addLayer(marker)
      this.searchLayer.addLayer(layer)
    },
  },
  created() {
    this.addActionsToAtuPopup()
  },
}
